export var extractFileFormat = function extractFileFormat(jsonLd) {
  return jsonLd['schema:fileFormat'];
};